<template>
    <!-- 상단 영역 -->
    <header class="console-gnb new">
        <div class="logo-n-companies">
            <button type="button" class="btn-opsnow" id="home_login_gnb_logo" v-on:click="logoClick()">
            </button>

            <div id="select-company" class="company-container">
                <button type="button" class="btn-companies">{{selectedCompany}}</button>
                <div class="layer-console console-companies">
                    <fieldset class="search-word">
                        <legend>{{$t('COMMON.BUTTON.CAMEL.SEARCH')}}</legend>
                        <input type="text" id="company_search_word" name=""
                               :placeholder="$t('COMMON.SEARCH.ENTER_SEARCH')"><!--검색어 입력-->
                    </fieldset>
                    <ul v-if="userCompanyList !== null" class="list-companies">
                        <li v-for="company of userCompanyList" :key="company.cmpnId"
                            v-bind:class="{'selected': company.cmpnId == curCmpnId}">
                            <button v-on:click="selectCompany(company.cmpnId, company.cmpnNm)" type="button">{{company.cmpnNm}}</button>
                        </li>
                    </ul>
                </div>
            </div>

        </div>

        <div class="utils">
            <div class="ticker-wrapper">
                <ol class="list-gnb-notice">
                    <li v-for="item of noticeScrollDataList" :key="item.ntceId">
                        <a class="notice-gnb-item" v-on:click="moveNoticeView(item.ntceId)"
                           v-bind:data-state="item.ntceType">
                            <span class="notice-category">{{ $t('HEADER.NOTICE.TYPE.'+ item.ntceTypeNm) }}</span>
                            <p class="notice-item-title" style="cursor:pointer">{{item.ntceTitle}}</p>
                            <time datetime="" class="update">({{item.updtDt | moment("YYYY.MM.DD")}})</time>
                        </a>
                    </li>
                </ol>
            </div>

            <div class="notifications">
                <button id="gnb_noti_button" type="button" class="btn" data-icon="notice">
                    {{ $t('HEADER.NOTICE.TITLE') }}<!--공지사항-->
                </button>
                <div class="layer-console notification-container">
                    <ol v-if="noticePending" class="list-notification">
                        <div-loading :full="false"></div-loading>
                    </ol>
                    <ol class="list-notification" data-state="none" v-show="noticeList.length == 0">
                        <li>{{ $t('HEADER.NOTICE.NO_DATA') }}<!--등록된 공지사항이 없습니다.--></li>
                    </ol>
                    <ol class="list-notification" v-show="noticeList.length > 0">
                        <li v-for="item of noticeList" :key="item.ntceId">
                            <a href="#" v-on:click="moveNoticeView(item.ntceId)"
                               class="notification-item">
                                <span v-if="item.readYn == 'N'" class="none-read">읽지않음</span>
                                <span class="notification-title">[{{ $t('HEADER.NOTICE.TYPE.'+ item.ntceType) }}] {{item.ntceTitle}}</span>
                                <time datetime="" class="notification-update">{{item.updtDt | moment("YYYY.MM.DD")}}</time>
                            </a>
                        </li>
                    </ol>
                    <p class="btns" v-if="noticeList">
                        <a v-on:click="moveNoticeList()" class="btn-more cursor-pointer">{{
                            $t('HEADER.NOTICE.MORE')}}</a>
                    </p>

                </div>
            </div>

            <div v-if="isOpsnow" class="user-profile">
                <button type="button" class="btn user" data-icon="support">{{
                        $t('HEADER.SUPPORT') }}
                </button>

                <!-- Support Opsnow / Bespin -->
                <div class="layer-console console-user">
                    <ul class="list-console-user">
                        <li>
                            <button type="button" v-on:click="moveSupport()">{{ $t('HEADER.SUPPORTNEW') }}</button>
                        </li>
                        <li>
                            <button type="button" v-on:click="moveSupportLegacy()">{{ $t('HEADER.SUPPORTLEGACY') }}</button>
                        </li>
                    </ul>
                </div>
            </div>

            <button type="button" class="btn" data-icon="help" v-on:click="showGuide()">{{ $t('HEADER.GUIDE') }}
            </button>

            <div class="user-profile">
                <button type="button" class="btn user" data-icon="user">{{ maskData(loginUserNm) }}</button>
                <div class="layer-console console-user">
                    <ul class="list-console-user">
                        <template v-for="(setting) in settingsData">
                            <li :key="setting.id">
                                <button type="button" v-on:click="moveConsole(setting.url)">{{ setting.menuName[getLocale] }}</button>
                            </li>
                        </template>
                        <li class="logout">
                            <button type="button" v-on:click="logout()">{{ $t('COMMON.LOG_OUT') }}</button>
                        </li>
                    </ul>
                </div>
            </div>

            <Modal
                ref="plcySingleModal"
                :okFunction="noAuthorization"
                :call-on-hide="noAuthorization"
                :isOKOnly="true"
                :title="noAuthorizationPopup.title"
                :message="noAuthorizationPopup.content"
                :isShowPopup="noAuthorizationPopup.isShowPopup"
            />

            <!-- 동시 로그인 팝업-->
            <base-alert-popup
                ref="SmtLoginPopup"
                :content="SmtLoginPopup.content"
                :title="SmtLoginPopup.title"
                popup-ref="openSmtLoginPopup"
                confirm-button-color="#dc3545"
                @onConfirmAction="logout(true)"
            />

            <!-- 토근 만료 팝업-->
            <base-alert-popup
                ref="TokenExpirationPopup"
                :content="TokenExpirationPopup.content"
                :title="TokenExpirationPopup.title"
                popup-ref="openTokenExpirationPopup"
                confirm-button-color="#dc3545"
                @onConfirmAction="logout(false)"
            />

            <!-- 동시 로그인 팝업-->
            <base-confirm-popup
                ref="ConcurrentLoginPopup"
                :content="ConcurrentLoginPopup.content"
                :title="ConcurrentLoginPopup.title"
                popup-ref="openConcurrentLoginPopup"
                confirm-button-color="#dc3545"
                @onCancel="logout()"
                @onConfirmAction="logoutAllSession(true)"
            />
        </div>
        <div-loading v-if="isFinish" :full="true"></div-loading>
        <div class="tooltip-gnb tooltip_templates">
            <div id="tooltip-menu01">
                <dl class="menu-description">
                    <dt>{{$t('COLDSTART.TOOLTIP.POLICY_TITLE')}} <!--정책 관리--></dt>
                    <dd>
                        {{$t('COLDSTART.TOOLTIP.POLICY_DESC')}}<!--조직에 맞는 정책과 규칙을 추가하고, 수정 관리를 할 수 있습니다.-->
                    </dd>
                </dl>
                <div class="actions">
                    <button type="button" class="buttons" data-type="line-invert" v-on:click="finishTooltip()">{{$t('COLDSTART.BUTTON.COMPLETE')}}<!--완료--></button>
                </div>
            </div>
        </div>

        <pop-coldstart-step-first ref="popColdstartStepFirst" @nextStep="nextStep()"></pop-coldstart-step-first>
        <pop-coldstart-step-second ref="popColdstartStepSecond" @isFinish="isFinish = $event"></pop-coldstart-step-second>


        <aside id="toast-add-to-compliance" class="layout-toast-message">
            <h2 class="title">Notification</h2>

            <p class="message">
                {{ $t('POLICY.LABEL.ADD_EVALUATION')}}<!--정책이 검사 목록에 추가되었습니다.-->

                <router-link to="/compliance" class="buttons" data-type="ghost" data-size="s" data-icon-right="open"><span class="open">{{ $t('POLICY.BUTTON.GO_TO_ASSESSMENT_ITEM')}}<!--검사항목 바로가기--></span></router-link>
            </p>
            <button type="button" class="btn-close" v-on:click="closeToast()">토스트 메시지 닫기</button>
        </aside>

        <aside id="toast-comment" class="layout-toast-message">
            <h2 class="title">Notification</h2>

            <p class="message">
                {{ $t(toastMessage)}}<!--정책이 검사 목록에 추가되었습니다.-->
            </p>
            <button type="button" class="btn-close" v-on:click="closeToast()">토스트 메시지 닫기</button>
        </aside>
    </header>
</template>


<script>
    import popColdstartStepFirst from '../../../coldstart/popColdstartStepFirst';
    import popColdstartStepSecond from '../../../coldstart/popColdstartStepSecond';
    import { EventBus } from '../../event-bus'
    import ssoService from '@/services/common/keycloak.service';
    import {mapGetters} from "vuex";
    import BaseAlertPopup from '@/components/common/popup/BaseAlertPopup';
    import BaseConfirmPopup from '@/components/common/popup/BaseConfirmPopup';
    import GroupSelect from "../../GroupSelect/GroupSelect.vue";
    import Schedule from "../../../compliance/components/Schedule.vue";
    import Modal from "../../Modals/Modal.vue";
    import PlcyListToRemove from "../../../compliance/components/PlcyListToRemove.vue";

    const gnb = require('./gnb')
    export default {

        name: 'Header',
        components:{
            PlcyListToRemove, Modal, Schedule, GroupSelect,
            popColdstartStepFirst,
            popColdstartStepSecond,
            BaseAlertPopup,
            BaseConfirmPopup
          },
        data: function () {
            return {
                apiUrl: `${this.urls.portalUrl}`,
                svcMenuList: [],
                cmpnMenuAuth: null,
                securityMenuAuth: null,
                getTrialRemainDays: null,
                noticeList: [],
                noticeScrollDataList: [],
                //recentMenuList: [],
                // Submenu Variable
                menu: [],
                browserTimeZone: moment().format("Z"),

                userCompanyList: null,
                isOpsnow: false,

                isFinish:false, // coldstart compliance 완료 여부
                watchedUrl: '',
                noticePending: false, // 공지사항 loading flag..하 겁나 느림 이거
                toastMessage:'test',
                selectStatus: false,
                tokenKey: '',
                SmtLoginPopup: {
                    content: this.$t(`COMMON.POPUP.DESC.smt_login`),
                    title: this.$t(`COMMON.POPUP.TITLE.smt_login`),
                },
                TokenExpirationPopup: {
                    content: this.$t(`COMMON.POPUP.DESC.token_expiration`),
                    title: this.$t(`COMMON.POPUP.TITLE.notify`),
                },
                ConcurrentLoginPopup: {
                    content: this.$t(`COMMON.POPUP.DESC.concurrent_login`),
                    title: this.$t(`COMMON.POPUP.TITLE.concurrent_login`),
                },
                noAuthorizationPopup: {
                    content: this.$t(`COMMON.POPUP.DESC.API_ACCESS_DENIED`),
                    title: this.$t(`COMMON.POPUP.TITLE.NOTIFY`),
                    isShowPopup: false,
                },
                settingsData: [],
            }
        },
        created: function() {

            //gnb.GlobalMenu.init()
            //this.initEvent()
            //this.selectCompany(1)
            //this.$store.state.`.userNm = "dfadfds"

            this.checkColdstart()
            this.getUserCompanyList()
            this.$store.dispatch('common/setHomepageInfo', this.getLocale);
            //this.getHomepageInfo()
            this.getSettings()
            this.getNotReadNoticeScroll()
            this.getNoticeList()

            EventBus.$on("addPolicyToCompliance", e => {
                $('#toast-add-to-compliance').toggleAttr("data-show", "")
                setTimeout(function() {
                    $('#toast-add-to-compliance').toggleAttr("data-show")
                }, 5000);

            });

            EventBus.$on("toastComment", e =>{
                this.toastMessage = e

                $('#toast-comment').toggleAttr("data-show", "")
                setTimeout(function() {
                    $('#toast-comment').toggleAttr("data-show")
                }, 3000);
            })

            const domain = location.hostname.split('.').slice(1).join('.');
            this.isOpsnow = (domain === 'opsnow.com' || domain === 'opsnow360.com' || domain === 'sec-alertnow.com');

        },
        watch: {
            // 회사 변경 시
            curCmpnId : function(){
                this.checkColdstart()
                this.getUserCompanyList()
                this.getSettings()
                this.$store.dispatch('common/setHomepageInfo', this.getLocale);
                //this.getHomepageInfo()

            },
            isConcurrentLogin: function() {
                if(this.isConcurrentLogin) {
                    this.openConcurrentLoginPopup();
                }
            },
            isSmtLogin: function() {
                if(this.isSmtLogin) {
                    this.openSmtLoginPopup();
                }
            },
            isTokenExpiration: function() {
                if(this.isTokenExpiration) {
                    this.openTokenExpirationPopup();
                }
            }
        },
        mounted: function(){
            EventBus.$on("changeLocale", e => {
                //this.getRecentMenu()
                this.$store.dispatch('common/setHomepageInfo', this.getLocale)
                //this.getMenuPermission()
            })
            setTimeout(function(){
                gnb.ConsoleGNB.init()
            }, 1);
            if(this.isConcurrentLogin) {
                this.openConcurrentLoginPopup();
            }
        },
        destroyed: function() {
            // important to clean up!!
            document.removeEventListener('click', this.documentClick)
        },
        methods: {

            closeToast(){
                $('.layout-toast-message').toggleAttr("data-show")
            },
            closePopup: function () {
                $.magnificPopup.close()
            },
            async selectCompany(cmpnId, cmpnNm) {
                const result = await(this.updateLastSelectCompany(cmpnId));
                if (result.data.status == 'ok') {
                    this.$store.commit('setUserCurCompany', {cmpnId: cmpnId, cmpnNm: cmpnNm});
                    this.$store.commit('user/UPDATE_CURRENT_COMPANY', {cmpnId: cmpnId, cmpnNm: cmpnNm});
                    /* Chatbot Test*/``
                    this.$nextTick(function(){
                        gnb.ConsoleGNB.setCompany()
                    })
                    //this.$cookies.set('cc', uuid, {domain: global['sub_domain'], path: '/', expires: 365})
                }
                this.$store.commit('setVendorInfo', {vendorInfo:_.find(this.userCompanyList, {'cmpnId': this.curCmpnId}).vendor});
                this.getMenuPermission()

                this.selectTemplateList(cmpnId)
                this.selectAllAccount();

            },
            // 로그인한 유저의 각 서비스별 메뉴 권한 조회
            getMenuPermission() {
                let url = `/earth/api/portal/authgroup/menuList/${this.curCmpnId}`

                this.http.get(url)
                    .then(resp => {
                        if(resp.data.status == 'ok') {
                            let companyInfo = resp.data.result.cmpnList[0]
                            this.setShortCutMenu(companyInfo.service, true)
                        }
                    })
            },
            // 로그인한 유저가 권한에 따라 사용 가능한 회사 목록 조회
            async getUserCompanyList() {
                const svcId = 'gov'; // Service : Governance
                const url = `/api/authgroup/companyList/${svcId}`;
                try {
                    const response = await this.http.get(url);
                    const cmpnList = _.get(response, "data.result.cmpnList", {});
                    if (!this.Common.isEmptyObject(cmpnList)) {
                        this.userCompanyList = cmpnList;

                        gnb.ConsoleGNB.setCompany();

                        if(this.curCmpnId && _.find(cmpnList, {cmpnId: this.curCmpnId}) ) {
                            this.selectCompany(this.curCmpnId, this.selectedCompany);
                        } else {
                            this.movePortalEachWL()
                        }
                    } else {
                        console.error("getUserCompanyList: Empty company list");
                    }
                } catch(e) {
                    console.error("getUserCompanyList: ", e)
                }
            },
            movePortalEachWL: function() {
                this.noAuthorizationPopup.isShowPopup = true
            },
            // 로그인한 유저가 마지막으로 선택한 회사 정보 조회
            updateLastSelectCompany: function (cmpnId) {
                let url = `/api/users/current/company`
                let postData = {
                    curCmpnId: cmpnId
                };

                return this.http
                    .put(url, postData)
                    .then(res => res)

            },
            // 공지사항 리스트 조회
            getNoticeList: function () {

                let url = `${this.urls.apiGwUrl}/platform/v1/plat/legacy/support/noticelist`

                this.showEvent()
                this.noticePending = true

                let postData = {
                    'browserTimeZone': this.browserTimeZone
                }
                this.http
                    .post(url, postData)
                    .then(json => {
                        this.noticePending = false
                        for (let data of json.data.result.data) {
                            data.creaDt = moment(data.creaDt).format("YYYY.MM.DD")
                            data.ntceType = 'view_header_notice_type_' + data.ntceType;
                        }
                        this.noticeList = json.data.result.data
                        if (Number(json.data.totcnt) > 0) {
                            $('#gnb_noti_button').attr('data-badge', '1')
                        } else {
                            $('#gnb_noti_button').removeAttr('data-badge')
                        }

                    });
            },
            // 공지사항 리스트 조회
            getNotReadNoticeScroll: function () {

                let url = `${this.urls.apiGwUrl}/platform/v1/plat/legacy/scrolltextdata`

                let postData = {
                    'browserTimeZone': this.browserTimeZone
                }
                this.http
                    .post(url, postData)
                    .then(res => {
                        return res.data.result
                    })
                    .then(json => {

                        if(Number(json.notReadNtce) > 0){
                            $('#gnb_noti_button').attr('data-badge', '1')
                            // res.result.notReadNtce = '99+';
                        } else {
                            $('#gnb_noti_button').removeAttr('data-badge')
                        }

                        // if(Number(json.notReadNtce) > 99){
                        //     this.notReadNoticeCount = '99+';
                        // }else{
                        //     this.notReadNoticeCount = json.notReadNtce;
                        // }
                        for (let data of json.data) {
                            data.updtDt = moment(data.updtDt).format("YYYY.MM.DD")
                            data.ntceTypeNm = 'view_notice_' + data.ntceTypeNm
                        }
                        this.noticeScrollDataList = json.data
                        setTimeout(() => {
                            if( !this.noticeScriptBoolean){
                                let notice = $('.ticker-wrapper')
                                notice.easyTicker({
                                    direction: 'up',
                                    interval: 5000,
                                    visible: 1,
                                    mousePause: 1,
                                });
                            }
                            this.noticeScriptBoolean = true
                        },0)

                    });
            },
            showEvent: function () {
                $('#gnb_noti_button').toggleAttr('data-state', 'open')
            },
            hideEvent: function () {
                $('#gnb_noti_button').removeAttr('data-state')
            },
            setShortCutMenu: function (serviceList, isReset) {
                this.svcMenuList = []
                this.cmpnMenuAuth = ''
                this.securityMenuAuth = ''

                for(let svcItem of serviceList) {
                    if(svcItem.svcId == 'gov') {

                        let curMenuUrl = '/' + this.$router.currentRoute.path.slice(1).split('/')[0]

                        let urlCheck = _.isNil(
                            _.find(svcItem.menuList, {"menuUrl": curMenuUrl, "authTypeCd" : this.constants.AUTH_TYPE.NONE})
                        );

                        if(!urlCheck) {  //'AUTH_TYPE_030': 수정권한, 'AUTH_TYPE_020': 조회권한, 'AUTH_TYPE_010': 권한없음
                            //해당 메뉴의 권한이 없을때 다른 메뉴가 존재하면 다음메뉴로 이동
                            let nextUrlList = _.find(svcItem.menuList, menu => {
                                return menu.menuId.startsWith('GOV')
                                    && menu.authTypeCd !== this.constants.AUTH_TYPE.NONE
                            });
                            if(!_.isNil(nextUrlList) ){
                                this.$router.push(nextUrlList.menuUrl)
                            } else {
                                this.noAuthorizationPopup.isShowPopup = true
                            }
                        }

                        this.$store.commit('setGovMenuAuth', {GOV_MENU_AUTH: svcItem.menuList})
                        this.svcMenuList.push(svcItem)
                    } else if(svcItem.svcId == 'portal') {
                        for (let menuItem of svcItem.menuList) {
                            if (menuItem.menuId == 'SP900') {
                                this.cmpnMenuAuth = menuItem.authTypeCd
                            }
                            if (menuItem.menuId == 'SP950') {
                                this.securityMenuAuth = menuItem.authTypeCd
                            }
                            svcItem.menuList = _.reject(svcItem.menuList, {menuId: 'SP900'})
                            svcItem.menuList = _.reject(svcItem.menuList, {menuId: 'SP950'})
                        }
                        this.svcMenuList.push(svcItem)
                    }else{
                        this.svcMenuList.push(svcItem)
                    }
                }

                this.$store.commit('setSvcMenuList', {svcMenuList: this.svcMenuList})

                if(this.$store.state.GOV_MENU_AUTH == null){
                    location.href(this.urls.portalUrl)
                }
                this.$nextTick( function(){
                    //this.initSubMenuLayoout()
                })

            },
            logoClick: function() {
                location.href = this.homepageInfo.svc.portalUrl
            },
            // Console 메뉴 이동
            noAuthorization() {
                this.moveConsole('/')
            },
            moveConsole: function (menuUrl) {
                location.href = `${this.urls.consoleUrl}/${menuUrl.slice(1)}`
            },
            moveNoticeView: function (ntceId) {
                location.href = `${this.urls.portalUrl}/notice/view/${ntceId}`
            },
            moveNoticeList: function(){
                location.href = `${this.urls.portalUrl}/notice`
            },
            //freshservice Site로 이동
            moveSupport: function () {
                window.open(this.urls.supportUrl)
            },
            moveSupportLegacy: function () {
                window.open(this.urls.supportLegacyUrl)
            },
            // Guide
            showGuide: function () {
                //window.open(`/guide/${this.getLocale}/user-guide-gov-${this.getLocale}.html`);
                if(this.isOpsnow) {
                    window.open(this.urls.supportUrl)
                }else{
                    window.open(`${this.portalUrl}/docs/console/${this.getLocale}/user-guide-console-${this.getLocale}.html`,'_blank');
                }
            },
            // Log Out
            logout: function (force) {

                if (force) {
                    ssoService.logoutAllSession();
                    ssoService.login();
                } else {
                    ssoService.logout({redirectUri: this.homepageInfo.svc.portalUrl});
                }
            },
            logoutAllSession: function(withoutCurrent) {
                ssoService.logoutAllSession(withoutCurrent);
            },
            // 거버넌스에서 사용되는 정책 템플릿 정보 조회
            selectTemplateList: function(cmpnId) {
                const url = `/api/governance/tmplt/list`
                let header = {
                    'cmpnId': cmpnId
                };

                this.http.post(url, JSON.stringify(header))
                    .then(result => {
                        if (result.data.status == 'ok') {
                            let templateList = [];
                            for (let tmplt of result.data.result) {
                                if (tmplt.basicFormation != '') {
                                    tmplt.basicFormation = JSON.parse(tmplt.basicFormation)
                                    tmplt.en = JSON.parse(tmplt.en)
                                    tmplt.ko = JSON.parse(tmplt.ko)
                                    tmplt.zh = JSON.parse(tmplt.zh)

                                    templateList.push(tmplt)
                                }
                            }
                            this.$store.commit('setTemplateList', {templateList: templateList})
                        }
                    });
            },
            // 최근 사용 메뉴 가져오기
            getRecentMenu() {
                let url = `/api/users/recent/menu/${this.getLocale}`

                this.http
                    .get(url)
                    .then(resp => {
                        if(resp.data.status == 'ok') {
                            this.recentMenuList = resp.data.result
                        }
                    });
            },
            // 거버넌스 콜드스타트 정보 조회
            async checkColdstart() {
                const url = "/api/governance/coldstart/info";
                const response = await this.http.post(url, {cmpnId : this.curCmpnId});
                const result = _.get(response, "data.result", null);
                if (result) {
                    // coldstart 진행 할지 말지 여부
                    if (result.popCmpltYn !== 'Y') {
                        this.$refs.popColdstartStepFirst.openPopup();
                    }

                    // coldstart 진행 할지 말지 여부
                    if(result.tltpCmpltYn !== 'Y') {
                        // view tooltip
                        this.$nextTick(function() {
                            const self = this;
                            setTimeout(function() {
                                self.showColdstartTooltip();
                            }, 1000)
                        });

                    }
                }
            },
            nextStep(){
                this.$refs.popColdstartStepSecond.openPopup()
            },
            showColdstartTooltip(){ // initViewGnb
                $('[data-trigger="tooltip-menu"]').tooltipster({
                    delay: 300,
                    trigger: 'click',
                    animation: 'fade',
                    updateAnimation: 'fade',
                    side: 'bottom',
                    theme: 'tooltip-menu tooltip-gnb',
                    arrow: true,
                    interactive: true,
                    contentAsHTML: true,
                    functionPosition: function(instance, helper, position) {
                        position.coord.left = helper.geo.origin.offset.left - 18
                        return position
                    }
                });
            },
            finishTooltip(){
                $('[data-trigger="tooltip-menu"]').tooltipster('hide')

                let url = `/api/governance/coldstart/tooltip`
                this.http.post(url, {cmpnId : this.curCmpnId})
                // .then(response=> {
                //     if (response.data.status === 'ok') {
                //         this.doColdstartTooltip = false
                //     }
                // });
            },
            // 유저 정보 박스 상태 변경 (펼침 <=> 닫힘)
            toggleUserInfo: function() {
                this.selectStatus = !this.selectStatus
            },
            openSmtLoginPopup: function() {
                this.$refs.SmtLoginPopup.show();
            },
            openConcurrentLoginPopup: function() {

                this.$refs.ConcurrentLoginPopup.show();
            },
            openTokenExpirationPopup: function() {
                this.$refs.TokenExpirationPopup.show();
                setTimeout(() => {
                    ssoService.logout();
                }, 3000);
            },
            selectAllAccount: function () {
                let url = `/api/governance/all/acnt`;
                let header = {
                    "cmpnId": this.curCmpnId,
                };
                let allAccount= []
                this.http.post(url, JSON.stringify(header))
                    .then(result => {
                        if (result.status === 200) {
                            this.$store.commit('setAllAccount', {allAccount: result.data.result.list})
                        }
                    });
            },
            getSettings() {
                let url = `${this.urls.apiGwUrl}/platform/v1/plat/settings`
                this.http.get(url)
                    .then(response => {
                        this.settingsData = response.data.result
                    });
            },
            maskData(userName) {
                const length = userName.length;

                // 한 글자인 경우 그대로 반환
                if (length === 1) {
                    return userName;
                }

                // 마스킹할 문자의 개수를 계산 (전체 길이의 1/3에 대한 올림)
                const maskLength = Math.ceil(length / 3);

                // 마스킹되지 않은 앞부분과 나머지를 '*'로 채움
                const visiblePart = userName.slice(0, length - maskLength);
                const maskedPart = '*'.repeat(maskLength);

                return visiblePart + maskedPart;
            }
        },
        computed: {
            ...mapGetters({
                isConcurrentLogin: 'user/isConcurrentLogin',
                isSmtLogin: 'user/isSmtLogin',
                isTokenExpiration: 'user/isTokenExpiration',
                curCmpnId: 'user/curCmpnId',
                selectedCompany: 'user/curCmpnNm',
                getTrial: 'user/userTrial',
                loginUserNm: 'user/loginUserNm',
                portalUrl: 'common/portalUrl',
                homepageInfo: 'common/homepageInfo'

            }),
            getLocale: function() {
                return this.$i18n.locale
            },
            getGovMenuList: function() {
                return this.$store.state.GOV_MENU_AUTH
            },
            getCurMenuURL: function() {
                return '/' + this.$route.path.slice(1).split('/')[0]
            }
        }



    }
</script>

<style>
    @import '../../../../../static/styles/gv_amchart.css';
</style>
<style scoped>
    .buttons[data-type=ghost]{
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/common/layout/gnb/gnb.vue